var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"v-button-mts--v2",attrs:{"type":_vm.type}},_vm.$listeners),[_c('BaseButtonWithLoader',{attrs:{"is-active":_vm.isLoading}},[_c('div',{staticClass:"v-button-mts--v2__content"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }